"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function SubProductsConsumer({
  isVisible
}: {
  isVisible: boolean;
}) {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {[...Array(3)].map((_, i) => <div key={i} className="h-[500px] rounded-lg bg-muted animate-pulse" />)}
      </div>;
  }
  if (error || posts.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {posts.map((post, i) => {
      const productImage = {
        src: post.customFields?.imagen || post.featuredImage,
        srcset: "",
        sizes: ""
      };
      return <div key={post.id} data-index={i} className={`group transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
        transitionDelay: `${i * 150}ms`
      }}>
            <Card className="relative h-full flex flex-col rounded-lg border border-border bg-card overflow-hidden transition-all duration-500 ease-out hover:-translate-y-2 shadow-md hover:shadow-xl">
              {}
              <div className="relative aspect-square overflow-hidden bg-muted">
                {productImage.src && <img src={productImage.src} data-wvc-srcset={productImage.srcset} data-wvc-sizes={productImage.sizes} alt={post.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />}
                {}
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center p-6">
                  <Button asChild variant="secondary" className="translate-y-4 group-hover:translate-y-0 transition-transform duration-500 font-bold tracking-widest uppercase text-xs">
                    <Link to={post.link || "#"}>
                      Ver Especificaciones
                    </Link>
                  </Button>
                </div>
              </div>

              {}
              <div className="p-8 flex flex-col flex-grow">
                <div className="mb-4">
                  <span className="font-default font-bold tracking-widest uppercase" style={{
                color: "var(--primary)",
                fontSize: "12px"
              }}>
                    {post.customFields?.product_category || "Producto"}
                  </span>
                </div>

                <h3 className="font-default font-semibold text-lg md:text-xl text-foreground mb-4 tracking-tight leading-tight">
                  {post.title}
                </h3>

                <div className="h-[2px] w-8 mb-6 transition-all duration-500 group-hover:w-16" style={{
              backgroundColor: "var(--accent)"
            }} />

                <p className="font-default font-light text-base leading-relaxed text-muted-foreground mb-8 line-clamp-3">
                  {post.customFields?.descripcion}
                </p>

                <div className="mt-auto">
                  <Button asChild variant="ghost" className="h-auto p-0 font-default font-bold tracking-widest uppercase text-xs hover:bg-transparent group/btn" style={{
                color: "var(--primary)"
              }}>
                    <Link to={post.link || "#"}>
                      Ver Detalles
                      <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                    </Link>
                  </Button>
                </div>
              </div>
            </Card>
          </div>;
    })}
    </div>;
}
export default function SubProductsGrid() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const cardsReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const wp_query_params = {
    post_type: "subproducto",
    per_page: 6,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="3504" id="sub-products-grid" className="bg-background text-foreground py-24 md:py-36 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={header.ref} className={`text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default font-bold tracking-[0.3em] uppercase mb-6" style={{
          color: "var(--primary)",
          fontSize: "11px"
        }}>
            Nuestra Disciplina
          </p>
          <h2 className="font-default font-extrabold text-5xl md:text-7xl lg:text-8xl tracking-tight text-foreground leading-[0.95] mb-6">
            PRODUCTOS
            <span style={{
            color: "var(--accent)"
          }}>.</span>
          </h2>
          <p className="font-default italic text-lg text-muted-foreground max-w-xl mx-auto">
            Soluciones estructurales diseñadas con precisión industrial.
          </p>
        </div>

        {}
        <div ref={cardsReveal.ref}>
          <PostsProvider wp_query={{
          post_type: "subproducto",
          per_page: 6,
          order: "desc",
          orderby: "date"
        }}>
            <SubProductsConsumer isVisible={cardsReveal.isVisible} />
          </PostsProvider>
        </div>
      </div>
    </section>;
}